import React from 'react';
import '../../styles/form.css';

export default function FormGrid({ children, className = '', ...props }) {
    return (
        <div className={`form-grid ${className}`} {...props}>
            {children}
        </div>
    );
}
